import { render, staticRenderFns } from "./SalesViewTicketStatus.vue?vue&type=template&id=bc3dafe4&scoped=true&"
import script from "./SalesViewTicketStatus.vue?vue&type=script&lang=js&"
export * from "./SalesViewTicketStatus.vue?vue&type=script&lang=js&"
import style0 from "./SalesViewTicketStatus.vue?vue&type=style&index=0&id=bc3dafe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3dafe4",
  null
  
)

export default component.exports